import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={13.327}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22015 42456"
    {...props}
  >
    <path
      d="M1339 11531 6104 1048h9807l4765 10483H1339zm14320 29877H6355c376-1485 2319-2620 4652-2620 2334 0 4277 1135 4652 2620zM6552 18869h-524v-2096h524v2096zm14938-6289c178 0 344-91 441-241 96-149 110-338 36-501L16726 307c-85-186-272-307-477-307H5766c-205 0-392 121-477 307L47 11838c-73 163-60 352 37 501 96 150 263 241 440 241h5242v3144h-262c-289 0-524 235-524 525v3145c0 290 235 524 524 524h1572c290 0 524-234 524-524v-3145c0-290-234-525-524-525h-262v-3144h3669v25177c-2935 193-5242 1992-5242 4176 0 289 235 523 525 523h10483c289 0 524-234 524-523 0-2184-2307-3983-5242-4176V12580h9959z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
